import { AxiosResponse } from "axios";
import api from "../apiService";
import { ApiResponse } from "types";
import {
	FormRequest,
	FormRequestQueryParams,
} from "features/webapp/form-request/type";

export const getFormRequestAPI = async (
	query: FormRequestQueryParams,
): Promise<any> =>
	new Promise(async (resolve, reject) => {
		try {
			const response: AxiosResponse = await api.get<FormRequest[]>(
				"/dashboard/form-requests",
				{
					...query,
					skip: query.skip * (query.take || 10),
				},
			);
			resolve(response.data);
		} catch (err) {
			reject(err);
		}
	});

export const updateFormRequestAPI = async <T = FormRequest>(
	id: string,
	payload: T,
): Promise<T> =>
	new Promise(async (resolve, reject) => {
		try {
			const response: AxiosResponse = await api.patch<ApiResponse<T>>(
				`dashboard/form-requests/${id}`,
				payload,
			);
			resolve(response.data.data);
		} catch (err) {
			reject(err);
		}
	});
export const getFormRequestDetailsAPI = async <T = FormRequest>(
	id?: string,
): Promise<T> =>
	new Promise(async (resolve, reject) => {
		try {
			const response: AxiosResponse = await api.get<ApiResponse<T>>(
				`dashboard/form-requests/${id}`,
			);
			resolve(response.data.data);
		} catch (err) {
			reject(err);
		}
	});
